import React from "react";
import Chip from "@mui/joy/Chip";
import Stack from "@mui/joy/Stack";
import Tooltip from "@mui/joy/Tooltip";
import { AdminOrderPromoCode, PromoBonusType, PromoBonusTypeLabels } from "../../models/promoCode";
import { formatMoneyKopecks } from "../bids/analytics/format";

type Props = {
    promoCodes?: AdminOrderPromoCode[];
    size?: "sm" | "md";
};

/** Бейджи промокодов заказа: код и сумма — скидка покупателю или недобор комиссии продавца. */
export function OrderPromoBadges({ promoCodes, size = "sm" }: Props) {
    if (!promoCodes || promoCodes.length === 0) {
        return null;
    }

    return (
        <Stack direction="row" gap={0.5} flexWrap="wrap">
            {promoCodes.map((p) => {
                const side = p.bonusType === PromoBonusType.Purchase ? "покупатель" : "продавец";
                return (
                    <Tooltip
                        key={p.promoCodeId}
                        title={`${PromoBonusTypeLabels[p.bonusType]} (${side} ${p.userId.toString()})`}
                        size="sm"
                    >
                        <Chip size={size} variant="soft" color="success">
                            {p.code} ({side}): −{formatMoneyKopecks(p.costKopecks)}
                        </Chip>
                    </Tooltip>
                );
            })}
        </Stack>
    );
}
